import { useState, useRef, useEffect } from "react";
import "../css/Calendario.css";

export default function CalendarFinTarjetas({ onSelect }) {
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState("");
    const [showCalendar, setShowCalendar] = useState(false);
    const [currentMonth, setCurrentMonth] = useState(today.getMonth());
    const [currentYear, setCurrentYear] = useState(today.getFullYear());

    const containerRef = useRef(null); // ⬅️ NUEVO

    const months = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const monthsLower = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDay = new Date(currentYear, currentMonth, 1).getDay();

    // ⬅️ CERRAR CALENDARIO CUANDO SE HAGA CLIC AFUERA
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setShowCalendar(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (day) => {
        const fechaFormateada =
            `${String(day).padStart(2, "0")} de ${monthsLower[currentMonth]} del ${currentYear}`;

        setSelectedDate(fechaFormateada);
        setShowCalendar(false);

        if (onSelect) onSelect(fechaFormateada);
    };

    return (
        <div className="datepicker-container" ref={containerRef}>
            <div className='text-inputAgregarTarjetas'>
                <label htmlFor="TituloAgregarTarjetas">Fecha Expiración</label>
            </div>

            <input
                className="datepicker-input"
                value={selectedDate}
                onClick={() => setShowCalendar(!showCalendar)}
                readOnly
                placeholder="Selecciona una fecha"
            />

            {showCalendar && (
                <div className="calendar-popup">

                    {/* HEADER */}
                    <div className="calendar-header">
                        <button
                            onClick={() => {
                                if (currentMonth === 0) {
                                    setCurrentMonth(11);
                                    setCurrentYear(currentYear - 1);
                                } else {
                                    setCurrentMonth(currentMonth - 1);
                                }
                            }}
                        >
                            {"<"}
                        </button>

                        <span>{months[currentMonth]} {currentYear}</span>

                        <button
                            onClick={() => {
                                if (currentMonth === 11) {
                                    setCurrentMonth(0);
                                    setCurrentYear(currentYear + 1);
                                } else {
                                    setCurrentMonth(currentMonth + 1);
                                }
                            }}
                        >
                            {">"}
                        </button>
                    </div>

                    {/* GRID */}
                    <div className="calendar-grid">
                        {["D", "L", "M", "M", "J", "V", "S"].map((d, i) => (
                            <div key={i} className="calendar-day-header">{d}</div>
                        ))}

                        {Array(firstDay).fill(null).map((_, i) => (
                            <div key={"e" + i} className="calendar-empty"></div>
                        ))}

                        {Array(daysInMonth).fill(null).map((_, i) => {
                            const d = i + 1;

                            return (
                                <div
                                    key={d}
                                    className="calendar-day"
                                    onClick={() => handleSelect(d)}
                                >
                                    {d}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}